// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"339f240e","453":"5c613ba8","553":"e17ac212","977":"b9e3a9d5"}[chunkId] + ".chunk.js";
};